    <div [formGroup]="form" class="suspend-exam-container" *ngIf="datasource && showDialog">
        <mat-form-field appearance="outline"
                        class="mt-3 se-form-field full-width">
            <mat-label>{{'SuspensionReason' | translate}}</mat-label>
            <mat-select #suspend id="suspend" formControlName="suspend" (selectionChange)="_onComboSelectionChange($event)" required>
                <mat-option *ngFor="let item of datasource" [value]="item.guid"> {{ item.description }} </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
